import $ from 'jquery';
import Swiper, { Pagination, EffectFade } from 'swiper';

function initHeroBannerSlider() {
  $(function () {
    if ($('.hero-banner-slider').length <= 0) {
      return;
    }
    $('.hero-banner-slider').each(function () {
      let slider = $(this).find('.swiper-container');
      let pagination = $(this).find('.swiper-pagination');

      let swiper = new Swiper(slider.get(0), {
        modules: [Pagination, EffectFade], // Include EffectFade here
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        effect: 'fade', // Make sure to set the effect as 'fade'
        pagination: {
          el: pagination.get(0),
          clickable: true
        },
        fadeEffect: {
          crossFade: true // Optional: set to true for a smooth cross-fade transition
        }
      });
    });
  });
}

export { initHeroBannerSlider };